var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceivedDashboardDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 17.5013C27.8477 16.4334 26.0408 15.907 24.2141 16.0099C22.3873 16.1128 20.651 16.8387 19.2947 18.0667C17.9383 19.2947 17.0439 20.9506 16.7605 22.7581C16.4771 24.5657 16.8219 26.4158 17.7373 28H4C3.64638 28 3.30724 27.8595 3.05719 27.6095C2.80714 27.3594 2.66666 27.0203 2.66666 26.6667V5.33333C2.66666 4.97971 2.80714 4.64057 3.05719 4.39052C3.30724 4.14048 3.64638 4 4 4H13.8853L16.552 6.66667H28C28.3536 6.66667 28.6928 6.80714 28.9428 7.05719C29.1929 7.30724 29.3333 7.64638 29.3333 8V17.5013ZM26.6667 22.6667H30.6667V25.3333H26.6667V30L20 24L26.6667 18V22.6667Z",
    fill: "#2D5063"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedDashboardDark);
export default __webpack_public_path__ + "static/media/received-dashboard-dark.bf73121302306fa5684ffee8f1dab5e1.svg";
export { ForwardRef as ReactComponent };